<template lang="pug">

.align
  section.align-intro
    AppTitle.u-mb-sm(:title="$t('mantra')" )
    AppLink(to="https://baianat.github.io/align/" class="button-link" :title="$t('demo')") {{$t('demo')}}
    img.align-intro-img( src='https://cdn.baianat.com/static/resources/align/1.png', srcset='https://cdn.baianat.com/static/resources/align/1.png 1x, https://cdn.baianat.com/static/resources/align/1@2x.png 2x')

  section.align-features.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        h2.u-mb-mi {{$t('features')}}
        .grid.is-mb.is-tablet-6
          .column
            h4.align-title {{$t('commandsTitle')}}  #[span.align-bg-green {{$t('commands')}}]
            p {{$t('commandsDesc')}}
          .column
            h4.align-title {{$t('designTitle')}}  #[span.align-bg-orange {{$t('design')}}]
            p {{$t('designDesc')}}
          .column
            h4.align-title {{$t('easyTitle')}}  #[span.align-bg-yellow {{$t('easy')}}]
            p {{$t('easyDesc')}}
          .column
            h4.align-title {{$t('iconsTitle')}}  #[br] #[span.align-bg-purple {{$t('icons')}}]
            p {{$t('iconsDesc')}}

  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-tablet-6.is-middle
          .column.u-mb-sm
            img( src='https://cdn.baianat.com/static/resources/align/2.png', srcset='https://cdn.baianat.com/static/resources/align/2.png 1x, https://cdn.baianat.com/static/resources/align/2@2x.png 2x')
          .column.u-mb-sm
            AppTitle.u-mb-xs(:title="$t('possibilities')" tag="h2")
            p {{$t('possibilitiesDesc')}}

          .column.is-12.u-mt-md
          .column.u-mb-sm
            AppTitle.u-mb-xs(:title="$t('interactive')" tag="h2")
            p {{$t('interactiveDesc')}}
          .column.u-mb-sm
            AppTitle.u-mb-xs(:title="$t('colorpicker')" tag="h2")
            p {{$t('colorpickerDesc')}}
          .column.is-12.u-mt-md

          .column.u-mb-sm
            AppTitle.u-mb-xs(:title="$t('syntaxHighlighting')" tag="h2")
            p {{$t('syntaxHighlightingDesc')}}
          .column.u-mb-sm
            img( src='https://cdn.baianat.com/static/resources/align/3.png', srcset='https://cdn.baianat.com/static/resources/align/3.png 1x, https://cdn.baianat.com/static/resources/align/3@2x.png 2x')

          .column.is-12.u-mt-md


          .column.u-mb-sm
            img( src='https://cdn.baianat.com/static/resources/align/4.png', srcset='https://cdn.baianat.com/static/resources/align/4.png 1x, https://cdn.baianat.com/static/resources/align/4@2x.png 2x')

          .column.u-mb-sm
            AppTitle.u-mb-xs(:title="$t('hotkeys')" tag="h2")
            p {{$t('hotkeysDesc')}}


  section.align-install.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        AppTitle.u-mb-sm(:title="$t('installation')" tag="h2")
        prism(language="js" :code="install")

  section.align-cta.u-mt-lg
    AppTitle.u-mb-sm(:title="$t('startWriting')" tag="h2")
      AppLink(to="https://github.com/baianat/align" class="button-link " :title="$t('getStarted')") {{$t('getStarted')}}

  .u-mb-md

</template>
<style lang="stylus">
$clMain = #0030ff
$clGreen = #85e4d6
$clOrange = #f87a3c
$clYellow = #ffd16c
$clPurple = #ff5df6
$clBg = #e2e2e2

div.app.is-align
  overflow: hidden
  background: $clBg

.align
  &-intro
    padding-top: unitRes(100, 200)

    .u-heading
      position: relative
      z-index: 2

    h1
      div
        .u-heading-line:last-child
          div
            background: $clMain
            display: inline-block
            color: $clWhite

    h2, a
      position: relative
      z-index: 2

    &-img
      position: absolute
      right: 0
      top: 420px

  &-cta
    background-color: $clMain
    padding: unitRes(20, 160)
    color: $clWhite
    background-image: url('https://cdn.baianat.com/static/resources/align/5.png')
    background-repeat: repeat-y
    background-position: 80% 120%
    background-attachment: fixed

    .button-link
      color: $clYellow
      background-image: linear-gradient(to right, $clYellow 0%, $clYellow 100%)

      &:hover
        color: $clOrange
        background-image: linear-gradient(to right, $clOrange 0%, $clOrange 100%)

  &-title
    line-height: 1.2

    >span
      display: inline-block

  &-bg
    &-main
      background: $clMain
      display: inline-block
      color: $clWhite

    &-green
      background: $clGreen

    &-orange
      background: $clOrange

    &-purple
      background: $clPurple

    &-yellow
      background: $clYellow

html[lang^='ar']
  .align
    &-cta
      background-position: 20% 120%

    &-intro
      &-img
        right: auto
        left: 0
        transform: scaleX(-1)
        filter: FlipH
</style>

<script>
import Prism from '~/components/Prism';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-align  ',
    logoText: '__NONE__',
    logoIcon: 'logoAlignTypo'
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Prism
  },
  data: () => ({
    install: `npm install @baianat/align
// or use yarn
yarn add @baianat/align

// Usage

// Include necessary files
<head>
  <link rel="stylesheet" href="dist/css/align.css">
  <!-- use editor's theme -->
  <!-- or create your own -->
  <link rel="stylesheet" href="dist/css/default-theme.css">
  <!-- @baianat/colorpicker stylesheet -->
  <link rel="stylesheet" href="path-to-colorpicker/css/colorpicker.css">
</head>
<body>
    ...
    <!-- @baianat/colorpicker script file -->
    <script type="text/javascript" src="path-to-colorpicker/js/colorpicker.j"><\/script>
    <script type="text/javascript" src="dist/js/align.js"><\/script>
</body>

// HTML Layout

<div class="align"></div>

<script>
  new Align('.align', {
    // settings
  });
<\/script>
`
  })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Align",
    "pageDesc":"Create posts in a friendly way with Baianat editor Align. Customize your options and take full control over your content layout.",
    "mantra":"Advanced content |building",
    "demo":"Demo",
    "features":"Features",
    "commandsTitle":"Dynamic array of",
    "commands":"commands",
    "commandsDesc":"Customize the features you want to include and also add your own commands.",
    "design":"design",
    "designTitle":"Flexible content ",
    "designDesc":"Take full control over your content’s layout beyond traditional post building.",
    "easy":"easy",
    "easyTitle":"Resource uploading made",
    "easyDesc":"Handle uploaded media with simple and direct events using Align’s friendly event bus.",
    "icons":"icons",
    "iconsTitle":"Bring your own",
    "iconsDesc":"Customize align icons in seconds by simply modifying some SVG paths.",
    "possibilities":"Unlimited |possibilities",
    "possibilitiesDesc":"Align comes with several commands out of the box. Define those you want to include and also introduce your personalized commands in a component-like approach.",
    "interactive":"Interactive |backgrounds",
    "interactiveDesc":"Choose to set a parallax effect or add a video to your backgrounds to make your content more engaging.",
    "colorpicker":"Integrated |Colorpicker",
    "colorpickerDesc":"Enjoy a colorful experience using a built-in colorpicker made for Vue that comes with Align out of the box.",
    "syntaxHighlighting":"Syntax |Highlighting",
    "syntaxHighlightingDesc":"Align uses Highlight.js under the hood to highlight any code snippets you might include, to serve your tech needs.",
    "hotkeys":"Write faster |with hotkeys",
    "hotkeysDesc":"Kick up the productivity gear with different hotkeys for most of Align’s commands for both Windows and macOS.",
    "installation":"Installation |and Usage",
    "startWriting":"Start writing |with Align.",
    "getStarted":"Get started"
  },
  "ar": {
    "pageTitle":"Align",
    "pageDesc":"شارك المقالات بطريقة سهلة من خلال محرر بيانات Align. يمكنك تخصيص الخيارات الخاصة بك والتحكم الكامل في تخطيط محتواك أفضل",
    "mantra":"انشأ محتواك |بشكل متطور. ",
    "demo":"عرض",
    "features":"المميزات",
    "commandsTitle":"مجموعة ديناميكية من ",
    "commands":"الأوامر",
    "commandsDesc":"خصص المميزات التي تريد إدراجها، وقم بإضافة الأوامر الخاصة بك.",
    "design":"مرن",
    "designTitle":"تصميم محتوى ",
    "designDesc":"تحكم تمامًا في تنسيق المحتوى الخاص بك على عكس البناء التقليدي للنشر الذي تعرفه.",
    "easy":"سهلًا",
    "easyTitle":"تحميل المصادر أصبح",
    "easyDesc":"تعامل مع الوسائط التى تقوم برفعها من خلال events سهل ومباشر، باستخدام . Align’s event bus سهل.",
    "icons":"الأيقونات",
    "iconsTitle":"جهز ",
    "iconsDesc":"خصص أيقونات align فى ثوان عن طريق تعديل بعض مسارات SVG.",
    "possibilities":"إمكانات غير |محدودة",
    "possibilitiesDesc":"Align يأتي مع العديد من الأوامر، حدد ما تريد إدراجه وأدخل الأوامر المخصصة الخاصة بك في نهج يشبه المكون.",
    "interactive":"خلفيات |تفاعلية",
    "interactiveDesc":"اختر لتعيين تأثير parallax أو حتى أضف فيديو إلى خلفية محتواك لتجعله أكثر جاذبية.",
    "colorpicker":"مُنتقي ألوان |متكامل",
    "colorpickerDesc":"استمتع بتجربة أداة غنية بالألوان تم تصميمه لـ Vue والذي يأتي مع Align.",
    "syntaxHighlighting":"تمييز |النصوص",
    "syntaxHighlightingDesc":"Align يستخدم Highlight.js لتسليط الضوء على أي رموز برمجية التي يمكن إدراجها لخدمة احتياجاتك التقنية.",
    "hotkeys":"اكتب أسرع باستخدام |مفاتيح الاختصارات",
    "hotkeysDesc":"يمكنك رفع مستوى أدائك بفضل مفاتيح الاختصارات لمعظم أوامر Align لكل منWindows و macOS.",
    "installation":"التثبيت |والاستخدام",
    "startWriting":"اكتب بسلاسة |مع Align. ",
    "getStarted":"ابدأ الآن!"
  }
}
</i18n>
